import { V3Transaction } from '../../../../models/v3-transaction'

import TransactionPanelCard from './TransactionPanelCard'
import { PanelContainer } from '../../../../atom/panel/panel'

interface props {
  loading: boolean
  selectedTransaction: V3Transaction
  position: number
  rowIndex: number
  totalTransactions: number
  onShowPanel: () => void
  reloadTransactions: () => void
}

const TransactionPanel: React.FC<props> = ({
  loading,
  selectedTransaction,
  position,
  rowIndex,
  onShowPanel,
  totalTransactions,
  reloadTransactions,
}) => {
  if (rowIndex === 0) {
    rowIndex = 1
  }

  return (
    <PanelContainer
      className="container"
      position={rowIndex * position}
      total={totalTransactions}
      $noBorder
      $compactTop
      $compactBottom
    >
      <TransactionPanelCard loading={loading} selectedTransaction={selectedTransaction} onShowPanel={onShowPanel} reloadTransactions={reloadTransactions} />
    </PanelContainer>
  )
}

export default TransactionPanel

